import './HR.css'

interface Props {
  className?: String
}

const HR: React.FC<Props> = (props) => {
  if (props.className !== undefined)
    return <hr className={props.className?.toString()}></hr>
  return (<hr></hr>)
}

export default HR